export const GROUP_CONVERSATION_QUESTION =
  'In a group conversation, you usually...'

export const GROUP_CONVERSATION_OPTIONS = [
  { key: 'takeTheLead', i18nKey: 'takeTheLead' },
  { key: 'mostlyListen', i18nKey: 'mostlyListen' },
  { key: 'bothEqually', i18nKey: 'bothEqually' },
] as const
